import cn from 'classnames';
import type React from 'react';
import { forwardRef } from 'react';
import TextareaAutosize, { type TextareaAutosizeProps } from 'react-textarea-autosize';
import * as st from './styles.module.scss';

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  autosize?: boolean;
  firstLetterUppercase?: boolean;
  label?: string;
  onChagne?: (e: string) => void;
}

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(
  ({ label, autosize = false, firstLetterUppercase, ...props }, ref) => {
    return (
      <div className={st.wrapper}>
        {autosize ? (
          <TextareaAutosize
            className={cn(st.textarea, firstLetterUppercase && st.firstLetterUppercase)}
            {...(props as TextareaAutosizeProps)}
            ref={ref}
          />
        ) : (
          <textarea
            className={cn(st.textarea, firstLetterUppercase && st.firstLetterUppercase)}
            {...props}
            ref={ref}
          />
        )}
        {label && <label htmlFor={props.id}>{label}</label>}
      </div>
    );
  }
);
